module.exports = __webpack_public_path__ + "img/logo_sum.8c74e970.svg";